import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=36f104b8&scoped=true&"
import script from "./Quote.vue?vue&type=script&lang=js&"
export * from "./Quote.vue?vue&type=script&lang=js&"
import style0 from "./Quote.vue?vue&type=style&index=0&id=36f104b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f104b8",
  null
  
)

export default component.exports